import { CurrentUser } from 'src/api/endpoints/auth/api';
import { Navigate, Outlet } from 'react-router-dom';
import { FC, ReactElement } from 'react';
import Loader from 'src/components/Loader';

export type AnonymousRouteProps = {
    user?: CurrentUser | null;

    // Default /
    redirectPath?: string;
    element?: ReactElement;
};

export const AnonymousRoute: FC<AnonymousRouteProps> = (
    props: AnonymousRouteProps
): ReactElement => {
    const { redirectPath = '/', user, element } = props;

    if (user === undefined) return <Loader />;

    if (user) return <Navigate to={redirectPath} replace={true} />;

    return element ?? <Outlet />;
};
